import { onBeforeUnmount, onMounted, useBlokkli } from "#imports";
export default function(cb) {
  const { tour } = useBlokkli();
  onMounted(() => {
    tour.add(cb);
  });
  onBeforeUnmount(() => {
    tour.remove(cb);
  });
}
